module.exports = __webpack_public_path__ + "img/鼎锐联仓储管理软件.c2ac3914.png";